<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import sattalep from "@/models/sattalep";
import AddEdit from "./addedit.vue";

export default {
  mixins: [apibtoast, apigeneric, sattalep],
  page: {
    title: "Talep",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("sattaleponay.Title"),
      items: [
        {
          text: this.$t("sattaleponay.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("sattaleponay.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("sattaleponay.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      TableUpdate: 0,
      DataUpdate: "",
      AddEdit: "",
      Id: "",
      TalepTitle: "",
      Onaydurum: {
        2: "Onay Bekleyenler",
        3: "Onaylandı",
        4: "Reddedildi",
        5: "Satın Alamaya Gönderildi",
      },
      FilterOnaydurum: 2,
      FilterBaslik: "",
    };
  },
  watch: {
    TableUpdate() {
      if(this.TableUpdate == 1){ 
        this.Get()
      }
    },
  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "sattalep",
        Page: this.Page,
        Filter: "&Desc=Taleptarih&Onaydurum=" + this.FilterOnaydurum + "&Baslik=" + this.FilterBaslik,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.TableUpdate = 0;
      });
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-9">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <input type="text" @input="FilterBaslik.length >= 3 || FilterBaslik.length == 0 ? Get() : ''" v-model="FilterBaslik" class="form-control" :placeholder="$t('sattaleponay.Page.Arama')" />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="text-sm-end">
                    <select v-model="FilterOnaydurum" class="form-select" type="text" @change="Get()">
                      <option v-for="(DataArray, index) in Onaydurum" :key="index" :value="index">
                        {{ DataArray }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("sattaleponay.Table.Baslik") }}</th>
                      <th>{{ $t("sattaleponay.Table.Birimid") }}</th>
                      <th>{{ $t("sattaleponay.Table.Taleptarih") }}</th>
                      <th>{{ $t("sattaleponay.Table.Onaydurum") }}</th>
                      <th style="width: 100px; text-align: center;">{{ $t("sattaleponay.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Baslik }}</th>
                      <td>{{ Data.BirimAdi }}</td>
                      <td>{{ Data.Taleptarih | formatDateTable }}</td>
                      <td>{{ Onaydurum[Data.Onaydurum] }}</td>
                      <td style="width: 100px; text-align: center;">
                        <b-button-group>
                          <b-button variant="primary" v-tooltip="$t('sattaleponay.Table.Incele')" v-b-modal.sattaleponay @click="(DataUpdate = Data), (TalepTitle = Data.Baslik), (Id = Data.Id)"><i class="fas fas fa-eye"></i></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :DataTalep="DataUpdate" :Id="Id" :TalepTitle="TalepTitle" @TableUpdate="TableUpdate = 1"/>
    </Layout>
  </Loader>
</template>
